import { css } from '@emotion/css';
import { button2Style, valueStyle } from '../../../shared/styles/text';
import { Vehicle } from '../../../shared/types/server-types';
import { CheckCircleSolid, PlusIcon } from '../../../shared/assets/icons';
import { Colors } from '../../../shared/styles/colors';
import { useNavigator } from '../../../routing/navigator';
import { Motion, Radius, Shadow } from '../../../shared/styles/tokens';

interface IVehicleDropdownProps {
  dropdownVisible: boolean;
  setDropdownVisible(prop: boolean): void;
  vehicles: Vehicle[];
  selectedVehicle: Vehicle;
  setSelectedVehicle: any;
}

export const VehicleDropdown = (props: IVehicleDropdownProps): JSX.Element => {
  const {
    vehicles,
    setSelectedVehicle,
    selectedVehicle,
    setDropdownVisible,
    dropdownVisible,
  } = props;
  const navigator = useNavigator();

  return (
    <ul
      className={vehicleDropdownStyle(dropdownVisible)}
      role="listbox"
      aria-label="Vehicle"
    >
      {vehicles.map((vehicle: Vehicle, index: number) => (
        <li
          onClick={() => {
            setSelectedVehicle(vehicle);
            setDropdownVisible(false);
          }}
          key={index}
          role="option"
          aria-selected={selectedVehicle === vehicle}
        >
          <span>{vehicle.registration}</span>
          <CheckCircleSolid
            className={isVisibleStyle(selectedVehicle === vehicle)}
          />
        </li>
      ))}
      <li onClick={navigator.toVehicles}>
        <PlusIcon />
        <span>add a vehicle</span>
      </li>
    </ul>
  );
};

const vehicleDropdownStyle = (dropdownVisible: boolean) => css`
  display: ${dropdownVisible ? 'flex' : 'none'};
  position: absolute;
  bottom: 100%;
  left: 0px;
  width: 100%;
  flex-direction: column;
  list-style: none;
  box-shadow: ${Shadow.raised};
  border: 1px solid ${Colors.BORDER};
  border-radius: ${Radius.md};
  overflow: hidden;
  z-index: 4;
  li {
    ${valueStyle}
    display: flex;
    text-transform: uppercase;
    width: 100%;
    padding: 1rem 1rem 0.9375rem 1rem;
    background: white;
    justify-content: space-between;
    border-bottom: 1px solid ${Colors.BORDER};
    min-height: 3.5rem;
    cursor: pointer;
    transition: background-color ${Motion.fast};
    span {
      align-self: center;
      display: inline-flex;
      align-items: center;
    }
    svg path {
      fill: ${Colors.CAPRI_BLUE};
    }
    @media (hover: hover) {
      &:hover {
        background: ${Colors.SURFACE};
      }
    }
    &[aria-selected='true'] {
      background: ${Colors.CAPRI_BLUE_TINT};
    }
    &:last-child {
      ${button2Style}
      border-bottom: none;
      justify-content: left;
      color: ${Colors.CAPRI_BLUE};
      svg path {
        stroke: ${Colors.CAPRI_BLUE};
      }
      span {
        margin-left: 0.5rem;
      }
    }
  }
`;

const isVisibleStyle = (isVisible: boolean) => css`
  visibility: ${isVisible ? 'visible' : 'hidden'};
`;
